import(/* webpackMode: "eager", webpackExports: ["MyAccountSkeleton"] */ "/vercel/path0/apps/web/src/components/ui/skeletons/my-account-skeleton.tsx");
